<template>
  <div class="modal__core">
    <div class="modal__header">
      <p class="modal__title">
        {{ $t("Guardar simulação") }}
      </p>
    </div>

    <div class="modal__body">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form
          class="form"
          :class="submitting ? 'is-submitting' : ''"
          @submit.prevent="handleSubmit(submit)"
        >
          <div class="form__error" v-if="serverError">{{ serverError }}</div>

          <div class="form__fields">
            <b-vee-input
              rules="required"
              :label="$t('Nome da simulação')"
              v-model="fields.name"
              :placeholder="$t('O nome do projecto')"
            />
          </div>

          <div class="u-df u-jcsb u-aic">
            <b-button
              :loading="submitting"
              native-type="submit"
              type="is-primary"
              size="is-medium"
            >
              {{ $t("Seguinte") }}
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BVeeInput from "./buefy-vee-fields/BVeeInput";

export default {
  components: {
    ValidationObserver,
    BVeeInput,
  },

  data() {
    return {
      serverError: null,
      submitting: false,

      fields: {
        name: "",
      },
    };
  },
  methods: {
    submit() {
      this.$emit("save", { name: this.fields.name });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal__core {
  position: relative;
  background-color: #fff;
  color: #000;
  padding: 64px 129px 73px;
  max-width: 704px;
  margin: auto;
}
.modal__header {
  margin-bottom: 24px;
}

.modal__title {
  font-family: $font-family-title;
  font-weight: bold;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  font-size: 30px;
  line-height: 58px;
}

.modal__body {
  margin-bottom: 2em;
}
</style>
